/**
 * Internal dependencies
 */
import { SET_SCROLLBAR_COLOR } from '../actionTypes';
import { createAction } from '../action-creators';
import { RootState } from '../types';

export const setScrollbarWidth =
	createAction<RootState['scrollbarWidth']>(SET_SCROLLBAR_COLOR);
